import * as React from "react"

/**
 * React context used to determine if we're inside a code component.
 * @internal
 */
export const ComponentContainerContext = React.createContext(false)
